/* RESPONSIBLE TEAM: team-pricing-and-packaging */
export const COPILOT_PERMISSION = 'can_inbox__access_copilot';
export const NO_ACCESS = 'no_access';
export const LIMITED_USAGE = 'limited_usage';
export const UNLIMITED_USAGE = 'unlimited_usage';
